import React from 'react';

import { useFormikContext } from 'formik';

import { timezoneNames } from 'components/practice/Calendar/components/RBCalendar/components/CalendarSettings/lib';
import SectionList from 'components/practice/UserPreferences/components/SectionList';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Select from 'components/shared/Select/Select';

const PracticeTimezone = () => {
  const { setFieldValue, values } = useFormikContext();

  const handleTimezoneChange = (option) => {
    setFieldValue('timezone', option?.value);
  };

  const getSelectedTimezone = () => {
    return timezoneNames.find((tz) => tz.value === values?.timezone) || null;
  };

  return (
    <SectionList
      title="Practice time zone"
      description="Set your primary and additional time zones to better align your calendar across different regions.">
      <Select
        label="Practice time zone"
        options={timezoneNames}
        value={getSelectedTimezone()}
        onChange={handleTimezoneChange}
        isClearable={false}
      />
    </SectionList>
  );
};

export default withErrorBoundary(PracticeTimezone);
